import { ICreatorFieldsFragment } from '../../../apollo/graphqlSchema';
import { IAnalyticsObjectOwner, IAnalyticsUser } from '../../types';

const getNameOrEmail = (
  user: Pick<ICreatorFieldsFragment, 'name' | 'email'>,
) => {
  if (user.name !== '') {
    return user.name;
  } else {
    const atPos = user.email.indexOf('@');
    if (atPos >= 0) {
      return user.email.substring(0, atPos);
    } else {
      return user.email;
    }
  }
};
export const getAnalyticsUser = (
  user: Pick<ICreatorFieldsFragment, 'id' | 'name' | 'email'>,
): IAnalyticsUser => {
  return {
    id: user.id,
    name: getNameOrEmail(user),
    email: user.email,
  };
};

export const getCreator = (entity: {
  creator: ICreatorFieldsFragment;
}): IAnalyticsObjectOwner => ({
  creator: getAnalyticsUser(entity.creator),
});
